export default "__VITE_ASSET__3f38ef49__"